import React from 'react';
import { IconButton, Typography, TypographyProps, styled } from '@mui/material';
import { LYNKED_DEEP_GREY, LYNKED_DEEP_GREY_HOVER, LYNKED_RED, LYNKED_TRANSPARENT, LYNKED_WHITE } from '../../../../consts/colors';

const ButtonContent = styled(Typography)<TypographyProps & { enabled: string }>(({ theme, enabled }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '30%',
  borderWidth: '3px',
  borderStyle: 'solid',
  minWidth: '55px',
  height: '40px',
  lineHeight: '100%',
  backgroundColor: enabled === 'true' ? LYNKED_RED : LYNKED_TRANSPARENT,
  borderColor: enabled === 'true' ? LYNKED_DEEP_GREY : LYNKED_DEEP_GREY_HOVER,
  color: enabled === 'true' ? LYNKED_WHITE : LYNKED_DEEP_GREY,
  '&:hover': { backgroundColor: enabled === 'true' ? LYNKED_RED : LYNKED_TRANSPARENT },
}));

const ButtonWrapper = styled(IconButton)({
  borderRadius: '30%',
  padding: '8px',
});

export default function OpeningHourEnableButton({
  handleEnabledChange,
  button_text,
  value,
}: {
  handleEnabledChange: (value: boolean) => void;
  button_text: string;
  value: boolean;
}) {
  return (
    <ButtonWrapper id="opening_hour_enable_button" onClick={() => handleEnabledChange(!value)}>
      <ButtonContent enabled={value.toString()}>{button_text}</ButtonContent>
    </ButtonWrapper>
  );
}
